require('./hireCardOpenCreditStep5.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, formatAmount } = require('utilities/currencyHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const CardLegalViewerModal = require('components/cards/cardLegalViewerModal/cardLegalViewerModal');
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const ContactCenterNewValidationCards = require('components/hire/contactCenterValidationCards/contactCenterNewValidationCards');

// @constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    CREDIT_CARD_SUBTYPE_VISA,
    CREDIT_CARD_TYPE_VISA,
    EURO_SYMBOL,
    EURO_TEXT,
    FIFTH_STEP,
    HYPHEN,
} = require('constants/index');
const { VISA_OPEN_GDPR_PID } = require('constants/gdprPlacementIds');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const {
    ADD_NEW_SHIPPING_ADDRESS,
    MULTIPLE_OPERATIONS,
    VISA_OPEN_HIRE,
    messages: { VISA_OPEN_HIRE_AND_GDPR }
} = require('constants/operationTypes');
const { OPEN_CREDIT_CARD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');
const { NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const FILENAMES = require('constants/mortgageRequestFileNames');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class HireCardOpenCreditStep5 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleYesNoSignedDocuments = this.handleYesNoSignedDocuments.bind(this)


        const standard = `0000${props.immHireCardImageSelector.get('selectedImageId').substring(10)}`;
        this.state = {
            precontractualMailProductInfo: {
                productName: OPEN_CREDIT_CARD_PRODUCT_NAME,
                producto: CREDIT_CARD_TYPE_VISA,
                standard,
                subproducto: CREDIT_CARD_SUBTYPE_VISA
            }
        };
    }

    componentDidMount() {
        const { sendPrecontractualDocumentMail, showIneAndRevolving } = this.props;
        const { precontractualMailProductInfo } = this.state;

        if (!showIneAndRevolving) {
            sendPrecontractualDocumentMail(precontractualMailProductInfo);
            if (!__CONTACT_CENTER__) {
                //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
                this.props.setTermsAndCondsText('hireCardOpenCredit-hireCardOpenCredit_confirmationStepAgreementText');
            }
        }
    }

    onHandleChangeCheckBox = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, FIFTH_STEP)
    }
    onHandleChangeCheckBoxCC = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, FIFTH_STEP)
    }
    buildLegalConfirmationSection(showRevolvingDocument, amount) {
        const {
            contractName,
            immHireCardOpenCredit,
            sendMailParams,
            showIneAndRevolving,
            onHandleChangeCheckBoxCC,
            immFlagBasedFeatures,
            processEmail
        } = this.props;
        const { precontractualMailProductInfo } = this.state;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const immStep = immHireCardOpenCredit.getIn(['steps', FIFTH_STEP]);
        const agreementLabel = <FormattedText value="hireCardOpenCredit-step4NewCheckboxText" />;
        const agreementErrorMsg = formatText('hireCardOpenCredit-step4CheckboxErrorMsg');
        const documentINE = immHireCardOpenCredit.get('documentINE')
        const documentPolicy = immHireCardOpenCredit.get('documentPolicy')
        const newIntLoading = documentINE && documentPolicy

        if (newCardsFF) {
            return (
                <ContactCenterNewValidationCards
                    amount={amount}
                    agreementErrorMsg={agreementErrorMsg}
                    agreementLabel={agreementLabel}
                    contractName={contractName}
                    handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                    immStep={immStep}
                    isContractingProcess
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    processEmail={processEmail}
                    immHireCardOpenCredit={immHireCardOpenCredit}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    ineNotCall={newCardsFF}
                    newIntLoading={newIntLoading}
                    newCardsFF={newCardsFF}
                />
            );
        } else {
            return (
                <ContactCenterValidationCards
                    amount={amount}
                    agreementErrorMsg={agreementErrorMsg}
                    agreementLabel={agreementLabel}
                    contractName={contractName}
                    handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                    immStep={immStep}
                    isContractingProcess
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    processEmail={newCardsFF}
                    immHireCardOpenCredit={immHireCardOpenCredit}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    ineNotCall={newCardsFF}
                    newIntLoading={newIntLoading}
                    newCardsFF={newCardsFF}
                />
            );
        }

    }
    handleYesNoSignedDocuments(value) {
        const { printedAndSignedRadioChanged, enableButtonOffice, checkRadioButtonPolicy } = this.props

        checkRadioButtonPolicy(value === 'yes' ? true : false)
        // printedAndSignedRadioChanged('YES')
        // enableButtonOffice();
    }
    buildSummary() {
        const {
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : '%';
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${formatAmount(immHirePaymentMethod.get('value'), getLanguage(), 0)} ${paymentMethodSymbol}`;

        const addressValue = immProfile.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immProfile);

        return (
            <div className="hire-card-open-credit-step-five__summary row">
                <div className="col-xs-6 print-label">
                    <div className="hire-card-open-credit-step-five__summary-label">
                        <FormattedText value="hireCardOpenCredit-summarySelectedName" />
                    </div>
                    <div className="hire-card-open-credit-step-five__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="hire-card-open-credit-step-five__summary-label">
                        <FormattedText value="hireCardOpenCredit-summarySelectedLimit" />
                    </div>
                    <div className="hire-card-open-credit-step-five__summary-value--highlight">
                        <OneLineSymbolAmount
                            amountObject={limitObj}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(limitObj, true)}
                            trimDecimals={true}
                        />
                    </div>
                </div>
                <div className="col-xs-6 print-label">
                    <div className="hire-card-open-credit-step-five__summary-label">
                        <FormattedText value="hireCardOpenCredit-summaryPaymentMethod" />
                    </div>
                    <div className="hire-card-open-credit-step-five__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="hire-card-open-credit-step-five__summary-label">
                        <FormattedText value="hireCardOpenCredit-summaryShippingAddress" />
                    </div>
                    <div className="hire-card-open-credit-step-five__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        );
    }
    blockInfo() {
        const { operativeName } = this.props;
        return (

            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check block-info" hasCheckbox>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>

            </BlockInfo>
        );
    }
    handleOpenPdfNewTab() {
        const { immHireCardOpenCredit } = this.props;
        const document = immHireCardOpenCredit.get('documentINE');
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${document}`;
        if (document) {
            openBase64pdfInPrintWindow(pdf, true);
        }
    }
    buildPdfLink() {
        return (
            <>
                <div>
                    <h4 className="contract-loan-pdf-viewer__subtitle">
                        <strong>
                            <FormattedText value={`overdraftProtectionLoan-subtitleConfirmPage`} />
                        </strong>
                    </h4>
                    <div className="contract-actions-readed contract-payrollLoan-readed">

                        <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfNewTab()}>
                            <FormattedText value={'hireCardOpenCredit-hireCardOpenCredit_legalText'} />
                        </button>
                        <span><i className="signature-pattern-code-input__icon icon icon-check" />
                            <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                        </span>
                    </div>
                </div>

            </>
        )
    }
    handleOnPrint() {
        const { hireCardOpenCreditprintDocument, immHireCardOpenCredit, hireCardOpenCreditprintDocumentPolicy } = this.props;
        const documentINE = immHireCardOpenCredit.get('documentPolicy');


        if (documentINE) {
            const base64 = documentINE;
            const contentType = "application/pdf";
            const pdf = `data:${contentType};base64,${base64}`;
            const data = [base64ToBlob(pdf)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });
            const blobURL = URL.createObjectURL(blobObject);
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(blobURL, '', winparams);
            isPrintOfficeMode() ? hireCardOpenCreditprintDocumentPolicy() : hireCardOpenCreditprintDocument()
            if (printWindow) {
                printWindow.print();
            }

        }
    }
    handleDocumentReaded() {
        const { cardsConfimationScrollDownPolicy } = this.props;
        cardsConfimationScrollDownPolicy();
    }

    handleDownloadPdf() {
        const { immHireCardOpenCredit } = this.props;

        const documentINE = immHireCardOpenCredit.get('documentPolicy');
        const base64 = documentINE;
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${base64}`;
        let fileName = formatText(`hireCardOpenCreditStepPolicy-pdfDownload`) + "." + getExtension(contentType);
        downloadAsFile(base64ToBlob(pdf), contentType, fileName);

    }
    buildViewer() {
        const { immHireCardOpenCredit } = this.props;

        const documentINE = immHireCardOpenCredit.get('documentPolicy');
        if (documentINE) {
            let title = isPrintOfficeMode() ? formatText(`hireCardOpenCreditStepPolicy-titlePdfOffice`) : formatText(`hireCardOpenCreditStepPolicy-titlePdfWP`);
            const scale = 1.05;
            const viewerHeight = 480;
            const base64 = documentINE;
            const contentType = "application/pdf";
            const document = `data:${contentType};base64,${base64}`;

            return (
                <OKPdfViewer
                    onDownload={this.handleDownloadPdf}
                    pdfFile={document}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={this.handleOnPrint}
                    title={title}
                    showScroll
                    onScroll={this.handleOnScroll}
                    onDocumentReaded={this.handleDocumentReaded}
                />
            );
        } else {
            return <LoadingSection />;
        }
    }
    blockInfoOffice() {
        return (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check hire-card-open-credit-step-five__block-info-officine" hasCheckbox>
                <strong><FormattedText value="hireCardOpenCreditStep5-blockInfoOficineTitle" /></strong>
                <br />
                <br />
                <FormattedText value="hireCardOpenCreditStep5-blockInfoOficineSubTitle" />
            </BlockInfo>
        );
    }



    render() {

        const { immFlagBasedFeatures, immHireCardOpenCredit, immHireCreditLimit, operativeName, immPdfData, showIneAndRevolving, handleAgreementCheckboxChange, immHirePaymentMethod } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const { precontractualMailProductInfo } = this.state;
        const immStep = immHireCardOpenCredit.getIn(['steps', FIFTH_STEP]);
        const agreementLabel = <FormattedText value="hireCardOpenCredit-hireCardOpenCredit_confirmationStepAgreementText" />;
        const agreementChecked = (__CONTACT_CENTER__ && !showIneAndRevolving ? true : immStep.get('agreementChecked'));
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardOpenCredit-step4CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const operationProcessId = immHireCardOpenCredit.get('operationProcessIdInitPolicy')
        const multipleSignaturePatternParams = [{
            serviceCode: VISA_OPEN_HIRE
        }, {
            serviceCode: ADD_NEW_SHIPPING_ADDRESS
        }];
        const summaryContent = this.buildSummary();
        const hireCardTitleClassName = contactCenterClassName('print-title', 'hire-card-open-credit-step-five__title');
        const hireCardSubTitleClassName = contactCenterClassName('print-paragraph', 'hire-card-open-credit-step-five__subtitle');
        const preContractDocumentInfo = getCardsPreContractPdfData()['open_credit'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;
        const paymentMethodType = immHirePaymentMethod.get('type');
        const showRevolvingDocument = paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE;
        const amount = immHireCreditLimit.get('creditLimit');
        const legalConfirmationSection = this.buildLegalConfirmationSection(showRevolvingDocument, amount);
        const blockInfo = isPrintOfficeMode() && this.blockInfo();
        const agreeIneCheckbox = immHireCardOpenCredit.get('agreeIneCheckbox')
        const pdfLink = newCardsFF ? this.buildPdfLink() : null
        const PDFDcocument = this.buildViewer();
        const blockInfoOffice = isPrintOfficeMode() ? this.blockInfoOffice() : null;
        if (!pdfError && !showIneAndRevolving) {
            agreementCheckboxContent = (
                <div className="hire-card-open-credit-step-five__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardOpenCreditAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }
        if (agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={multipleSignaturePatternParams}
                    multiOTPMessageCode={VISA_OPEN_HIRE_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                />
            )
        }

        if (agreeIneCheckbox) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={multipleSignaturePatternParams}
                    multiOTPMessageCode={VISA_OPEN_HIRE_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                    isEasyLoanTypeAB={isPrintOfficeMode() && true}

                />

            )
        }

        if (newCardsFF) {
            if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
                return (
                    <article className="hire-card-open-credit-step-five">
                        <FormattedText
                            className={hireCardTitleClassName}
                            value="hireCardOpenCredit-step4Title"
                        />
                        <FormattedText
                            className={hireCardSubTitleClassName}
                            value="hireCardOpenCredit-step4Subtitle"
                        />
                        <br />
                        {summaryContent}
                        <OKConsents placementId={VISA_OPEN_GDPR_PID} />
                        <div className="hire-card-open-credit-step-five__pdf-viewer-container">
                            {pdfLink}
                            <br />
                            <div className="hire-card-open-credit-step-five__summary-label">
                                <FormattedText value="hireCardOpenCredit-infoLink" />
                            </div>
                            <br />
                            {blockInfoOffice}
                            <br />
                            {PDFDcocument}
                        </div>
                        {GDPRSignaturePatternContent}
                    </article>
                );
            } else {
                return (
                    <article className="hire-card-open-credit-step-five">
                        <FormattedText
                            className={hireCardTitleClassName}
                            value="hireCardOpenCredit-step4Title"
                        />
                        <FormattedText
                            className={hireCardSubTitleClassName}
                            value="hireCardOpenCredit-step4Subtitle"
                        />
                        {blockInfo}
                        <br />
                        {summaryContent}
                        <OKConsents placementId={VISA_OPEN_GDPR_PID} />
                        <WebappRender>
                            <div className="hire-card-open-credit-step-five__pdf-viewer-container">
                                {pdfLink}
                                <br />
                                <div className="hire-card-open-credit-step-five__summary-label">
                                    <FormattedText value="hireCardOpenCredit-infoLink" />
                                </div>
                                <br />
                                {PDFDcocument}
                                <br />
                            </div>
                        </WebappRender>
                        {agreementCheckboxContent}
                        <ContactCenterRender>
                            {showIneAndRevolving ?
                                legalConfirmationSection
                                : <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                            }

                        </ContactCenterRender>
                        {GDPRSignaturePatternContent}
                    </article>
                )
            }
        } else {
            return (
                <article className="hire-card-open-credit-step-five">
                    <FormattedText
                        className={hireCardTitleClassName}
                        value="hireCardOpenCredit-step4Title"
                    />
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={formatText(operativeName)}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <FormattedText
                        className={hireCardSubTitleClassName}
                        value="hireCardOpenCredit-step4Subtitle"
                    />
                    {summaryContent}
                    <OKConsents placementId={VISA_OPEN_GDPR_PID} />
                    <WebappRender>
                        <div className="hire-card-open-credit-step-five__pdf-viewer-container">
                            {showIneAndRevolving ?
                                <CardLegalViewerModal
                                    amount={amount}
                                    agreeCheckboxRevol={agreementChecked}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    isContractingProcess
                                    precontractualMailProductInfo={precontractualMailProductInfo}
                                    showRevolvingDocument={showRevolvingDocument}
                                />
                                : <PreContractualDocumentViewer
                                    preContractDocumentInfo={preContractDocumentInfo}
                                    titleKey="preContractDocument_pdfTitleINE"
                                />
                            }
                        </div>
                    </WebappRender>
                    {agreementCheckboxContent}
                    <ContactCenterRender>
                        {showIneAndRevolving ?
                            legalConfirmationSection
                            : <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        }

                    </ContactCenterRender>
                    {GDPRSignaturePatternContent}
                </article>
            );
        }

    }
}

HireCardOpenCreditStep5.propTypes = {
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardOpenCredit: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immPdfDownloadData: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    operativeName: PropTypes.string,
    requestPDFDownload: PropTypes.func,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object,
    setTermsAndCondsText: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCardOpenCreditStep5;
